import Page from 'components/Page';
import React, { Component } from 'react';
import axios from 'axios';
import ReactTable from "react-table";
// import Typography from 'components/Typography';
import "react-table/react-table.css";
import bg11Image from 'assets/img/bg/background_1920-11.jpg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Trashico from 'react-icons/lib/fa/trash-o';
import Mapico from 'react-icons/lib/fa/map-o';
import Editico from 'react-icons/lib/fa/pencil';
import Infoico from 'react-icons/lib/fa/info';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import Modal1 from "react-responsive-modal";
import Modal2 from 'react-awesome-modal';
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import {Modal as Modalku}  from 'reactstrap';
import {
  Card,
  ButtonGroup, 
  CardTitle,
  CardBody,
  CardImg,
  CardImgOverlay,
  CardText,
  CardLink,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Button,
  Badge,
  Label,
  // Modal,
  Input,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

// const switchku = require('rc-switch');

const tableTypes = ['', 'bordered', 'striped', 'hover'];

const pStyle = {
  fontSize: '15px',
  textAlign: 'left',
  width: '100px',
  margin: '5px'
};

const styles = {
  fontFamily: "sans-serif",
  textAlign: "center",
  width:"1000px"
};

const ExpansionPanel = withStyles({
  root: {
    border: '1px solid rgba(0,0,0,.125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  },
  expanded: {
    margin: 'auto',
  },
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0,0,0,.03)',
    borderBottom: '1px solid rgba(0,0,0,.125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(props => <MuiExpansionPanelSummary {...props} />);

ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';

const ExpansionPanelDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing.unit * 2,
  },
}))(MuiExpansionPanelDetails);

const mapStyles = {
  width: '800px',
  height: '400px',
};


export class Asassment extends Component {

  constructor(props) {
    super(props);

    this.handleSearch = this.handleSearch.bind(this);

    this.state = {
      data:[],
      kondisi: '',
      expanded: '',
      modal: false,
    modal_backdrop: false,
    modal_nested_parent: false,
    modal_nested: false,
    backdrop: true,
    fpondasi: '',
    fkolom: '',
    fatap: '',
    flangit: '',
    fdinding: '',
    flantai: '',
    open: false,
    open2: false,
    open3: false,
    longitude: '',
    latitude: '',
    alamat: '',
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: {},
    };
  }


  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };


  componentDidMount() {

    axios.get('https://backendmha.herokuapp.com/api/asassment')
    .then(res => {
      const data = res.data;
      this.setState({ data });

    }) 

  }


  handleSearch(e){
    if (e.target.value == ''){
      
      axios.get('https://backendmha.herokuapp.com/api/asassment')
      .then(res => {
        const data = res.data;
        this.setState({ data });
      })

      this.setState({ data : this.state.data });

    }else {

      axios.get('https://backendmha.herokuapp.com/api/asassment/'+e.target.value)
      .then(res => {
        console.log(" ini didmount"+res.data)
        const data = res.data;
        this.setState({ data });
      })

      this.setState({ data : this.state.data });

    }
  }

  notifydel = (string) => {
    toast.error(string, {
      position: toast.POSITION.BOTTOM_CENTER,
      position: "top-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
    });
  };

  onChangeswitch(value) {
    console.log(`switch checked: ${value}`); // eslint-disable-line
  }

  renderSwitch(param) {
    switch(param) {

      case 'Ringan':
        return  <Badge color="success" pill className="mr-1">Ringan</Badge>;
        case 'Sedang':
        return <Badge color="warning" pill className="mr-1">Sedang</Badge>;
      default:
        return <Badge color="danger" pill className="mr-1">Berat</Badge>;
    }
  }

  tooglestatus(id) {
    console.log(`tooggle status checked: ${id.fpondasi}`);
    const requestBody = {
      id: id.id,
      nik:id.nik,
      kab:id.kab,
kec:id.kec,
alamat:id.alamat,
long:id.long,
lot:id.lot,
nama:id.nama,
sektor:id.sektor,
kewenangan:id.kewenangan,
luas:id.luas,
harga:id.harga,
pondasi_l:id.pondasi_l,
pondasi_m:id.pondasi_m,
pondasi_h:id.pondasi_h,
pondasi_t:id.pondasi_t,
kolom_l:id.kolom_l,
kolom_m:id.kolom_m,
kolom_h:id.kolom_h,
kolom_t:id.kolom_t,
atap_t:id.atap_t,
langit_l:id.langit_l,
langit_m:id.langit_m,
dinding_m:id.dinding_m,
dinding_h:id.dinding_h,
dinding_t:id.dinding_t,
lantai_l:id.lantai_l,
lantai_t:id.lantai_t,
tingkat:id.tingkat,
fpondasi:id.fpondasi,
fkolom:id.fkolom,
flangit:id.flangit,
fdinding:id.fdinding,
flantai:id.flantai,
fatap:id.fatap,
status:'Diterima',
 }
  
  const config = {
    body: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }

  axios.put('https://backendmha.herokuapp.com/api/asassment/'+id.id, requestBody, config)
  .then(res => {
  })
}

tooglestatus2(id) {
  console.log(`tooggle2 status checked: ${id.fpondasi}`);
  const requestBody = {
    id: id.id,
    kab:id.kab,
kec:id.kec,
alamat:id.alamat,
long:id.long,
lot:id.lot,
nama:id.nama,
sektor:id.sektor,
kewenangan:id.kewenangan,
luas:id.luas,
harga:id.harga,
kondisi:id.kondisi,
pondasi_l:id.pondasi_l,
pondasi_m:id.pondasi_m,
pondasi_h:id.pondasi_h,
pondasi_t:id.pondasi_t,
kolom_l:id.kolom_l,
kolom_m:id.kolom_m,
kolom_h:id.kolom_h,
kolom_t:id.kolom_t,
atap_t:id.atap_t,
langit_l:id.langit_l,
langit_m:id.langit_m,
dinding_m:id.dinding_m,
dinding_h:id.dinding_h,
dinding_t:id.dinding_t,
lantai_l:id.lantai_l,
lantai_t:id.lantai_t,
tingkat:id.tingkat,
fpondasi:id.fpondasi,
fkolom:id.fkolom,
flangit:id.flangit,
fdinding:id.fdinding,
flantai:id.flantai,
fatap:id.fatap,
status:'Pending',
}

const config = {
  body: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}

axios.put('https://backendmha.herokuapp.com/api/asassment/'+id.id, requestBody, config)
.then(res => {
})
}

  renderStatus(param,id) {
    switch(param) {
      case 'Pending':
        return  ( <Switch  onChange={this.tooglestatus(id)} />);
      default:
        return (<Switch defaultChecked onChange={this.tooglestatus2(id)} />);
    }
  }

  handleDelete(index){
    // e.preventDefault();
    const self = this
    axios({
      method: 'delete',
      url: 'https://backendmha.herokuapp.com/api/asassment/'+index,
    })
   
    const data = self.state.data.filter(prod => prod.id !== index)
    self.setState({data})

    this.notifydel("Data Berhasil Dihapus!")

  }

  foto (id) {
    console.log(`TOOGLE MODAL: ${id.fpondasi}`);
    this.setState({
      fpondasi:id.fpondasi,
      fkolom:id.fkolom,
      fatap:id.fatap,
      flangit:id.flangit,
      fdinding:id.fdinding,
      flantai:id.flantai,
      });
      this.setState({ open: true });
  }

  map (id) {
    console.log(`TOOGLE MAP: ${id.long}`);
    console.log(`TOOGLE MAP: ${id.lot}`);
    this.setState({
      longitude: id.long,
      latitude: id.lot,
      alamat: id.alamat,
      });
      this.setState({ open2: true });
  }

  kondisi (id) {
    this.setState({
      kondisi: id.kondisi,
      });
      this.setState({ open3: true });
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  onOpenModal2 = () => {
    this.setState({ open2: true });
  };

  onCloseModal2 = () => {
    this.setState({ open2: false });
  };
  
  onCloseModal3 = () => {
    this.setState({ open3: false });
  };
  

  onMarkerClick = (props, marker, e) =>
  this.setState({
    selectedPlace: props,
    activeMarker: marker,
    showingInfoWindow: true
  });


  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      })
    }
  };
  


  render(){
    const { open } = this.state;
    const { open2 } = this.state;
    const { expanded } = this.state;
    const { data } = this.state;

    return (
      
      <Page
        title="Asassment"
        breadcrumbs={[{ name: 'Asassment', active: true }]}
        className="Asassment">
        {
<Col md={12} sm={12} xs={12} className="mb-3">
<Card>
  {/* <CardImg top src={bg11Image} /> */}
  <CardBody>
  <ToastContainer />
    <CardTitle>Data Asassment</CardTitle>
    <CardText>
      Data - data assasment yang di dapat dari masyarakat secara mandiri, dengan analisa tingkat kerusakan secara
       otomatis dengan metode analisa sesuai standar.

         <Col >
         <Row >
       <input type="text" style={pStyle} className="form-control col-md-3" placeholder="Pencarian" onChange={this.handleSearch.bind(this)}/>
           {/* <Label for="exampleSelect">Tingkat Kerusakan</Label> */}
           <Input style={pStyle} onChange={this.handleSearch.bind(this)} className="form-control col-md-3" type="select" name="select">
                    <option>Ringan</option>
                    <option>Sedang</option>
                    <option>Berat</option>
                    <option value="">Semua</option>
                  </Input>
                  <Input style={pStyle} onChange={this.handleSearch.bind(this)} className="form-control col-md-3" type="select" name="select">
                    <option>Pending</option>
                    <option>Diterima</option>
                    <option value="">Semua</option>
                  </Input>
         </Row> 
          </Col>

  
       
   
    </CardText>
    <ReactTable
         data={data}
         showFilters={true} 
         columns={[
          {
            Header: "NIK",
            accessor: "nik"
           },
          {
            Header: "Nama",
            accessor: "nama"
           },
          {
            Header: "Kabupaten",
            accessor: "kab",
          },
               {
                 Header: "Kecamatan",
                 accessor: "kec",
                 width: 80
               },
                {
                  Header: "Alamat",
                  accessor: "alamat"
                 },
                 {
                  Header: "Sektor",
                  accessor: "sektor",
                  width: 65
                 },
                 {
                  Header: "Kewenangan",
                  accessor: "kewenangan",
                 },
                 {
                  Header: "Luas (m2)",
                  accessor: "luas",
                  width: 80
                 },
                 {
                  Header: "Kerugian (Rp)",
                  accessor: "harga",
                  width: 80
                 },
                 {
                  Header: "Tingkat Kerusakan",
                  accessor: "tingkat",
                  width: 75,
                  Cell: row => (
                      <div>
                       {this.renderSwitch(row.original.tingkat)}
                      </div>
                  )
                 },
                 {
                  Header: "Status",
                  accessor: "status",
                  width: 63,
                  Cell: row => (
                      <div>
                       {this.renderStatus(row.original.status,row.original)}
                      </div>
                  )
                 },
                 {
                  Header: 'Aksi',
                  accessor: "id",
                  width: 150,
                  Cell: row => (
                      <div>
                        <ButtonGroup size="sm">
                        <Button  color="danger" className="cui-trash icons font-1xl  " onClick={this.handleDelete.bind(this,row.original.id)}> <Trashico> </Trashico> </Button>
                          <Button  color="primary" className="cui-note icons font-1xl  " onClick={this.foto.bind(this,row.original)} > <Infoico></Infoico>  </Button>
                          <Button  color="primary" className="cui-note icons font-1xl  "  onClick={this.map.bind(this,row.original)}  > <Mapico></Mapico> </Button>
                          <Button  color="primary" className="cui-note icons font-1xl  "  onClick={this.kondisi.bind(this,row.original)}  > <Editico></Editico> </Button>
                         </ButtonGroup>
                      </div>
                  )
               }
              ]}
              // pages={this.state.pages} // should default to -1 (which means we don't know how many pages we have)
              // loading={this.state.loading}
              defaultPageSize={10}
              sortable = {true}
              pageSizeOptions={[5, 10, 20, 25, 50]}
              // manual // informs React Table that you'll be handling sorting and pagination server-side
              // onFetchData={(state, instance) => {
              //   bodyFormData = new FormData();
              //   bodyFormData.set('length', state.pageSize);
              //   bodyFormData.set('start', state.page);
              //   bodyFormData.set('kolom', state.sorted);
              //   bodyFormData.set('order.0.dir', 'ASC');
              //   bodyFormData.set('search', state.filtered);
              //   console.log("ini state tablenya "+state.pageSize+" page : "+state.page+" sorted : "+state.sorted+" filtered :"+state.filtered)
              //   // show the loading overlay
              //   this.setState({loading: true})
              //   // fetch your data
                  
              //   axios.post('http://localhost:8000/api/pemeliharaanpage/',bodyFormData)
              //     .then((res) => {
              //       var pag = Math.ceil(res.data.filtered/res.data.limit);
              //       // console.log("PAG "+pag)
              //       this.setState({
              //         dataku : res.data,
              //         data: res.data.pages,
              //         pages: 10,
              //         loading: false
              //       })
              //     })
              // }}
       
       />
  </CardBody>
</Card>

<Modal1 open={this.state.open3} onClose={this.onCloseModal3} center showCloseIcon styles={styles}>
          <h2>Kondisi lingkungan sekitar</h2>
          {/* <p>
        Kondisi bersumber dari masyarakat pengguna layanan mass housing asassment. 
      </p> */}
      <Card>
            <CardBody>
              {/* <CardTitle>Card with image</CardTitle> */}
              <CardText>
               "{this.state.kondisi}"
              </CardText>
            </CardBody>
          </Card>
        </Modal1>


<Modal1 open={open} onClose={this.onCloseModal} center showCloseIcon styles={styles}>
          <h2>Foto Kerusakan Aset</h2>
          <p>
        Foto bersumber dari masyarakat pengguna layanan mass housing asassment. 
      </p>
<ExpansionPanel expanded={expanded === 'panel1'} onChange={this.handleChange('panel1')}>
          <ExpansionPanelSummary>
            <Typography>Kerusakan Atap</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          <CardImg style={{ width: 600, height: 300 }} top src={this.state.fatap} />
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel expanded={expanded === 'panel2'} onChange={this.handleChange('panel2')}>
          <ExpansionPanelSummary>
            <Typography>Kerusakan Dinding</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          <CardImg style={{ width: 600, height: 300 }} top src={this.state.fdinding} />
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel expanded={expanded === 'panel3'} onChange={this.handleChange('panel3')}>
          <ExpansionPanelSummary>
            <Typography>Kerusakan Kolom</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          <CardImg style={{ width: 600, height: 300 }} top src={this.state.fkolom} />
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel expanded={expanded === 'panel4'} onChange={this.handleChange('panel4')}>
          <ExpansionPanelSummary>
            <Typography>Kerusakan langit-langit</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          <CardImg style={{ width: 600, height: 300 }} top src={this.state.flangit} />
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel expanded={expanded === 'panel5'} onChange={this.handleChange('panel5')}>
          <ExpansionPanelSummary>
            <Typography>Kerusakan Lantai</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          <CardImg style={{ width: 600, height: 300 }} top src={this.state.flantai} />
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel expanded={expanded === 'panel6'} onChange={this.handleChange('panel6')}>
          <ExpansionPanelSummary>
            <Typography>Kerusakan Pondasi</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          <CardImg style={{ width: 600, height: 300 }} top src={this.state.fpondasi} />
          </ExpansionPanelDetails>
        </ExpansionPanel>
        </Modal1>

        <Modal2 visible={this.state.open2}
                    width="800"
                    height="400"
                    effect="fadeInDown"
                    onClickAway={() => this.onCloseModal2()} >
        {/* <h4>Lokasi Rumah</h4> */}
        <Col lg={12} md={6} sm={6} xs={12}> 

        <Map 
        onClick={this.onMapClicked}
        google={this.props.google}
  initialCenter={{
    lat: this.state.latitude,
    lng: this.state.longitude
   }}
   center={{
    lat: this.state.latitude,
    lng: this.state.longitude
   }}
   zoom={10}
    style={{width: '800px', height: '400px', position: 'absolute'}}
    className={'map'}
    zoom={11}>

  <Marker
  onClick={this.onMarkerClick}
    title={'Lokasi Rumah Korban'}
    alamat={this.state.alamat}
    position={{lat: this.state.latitude, lng: this.state.longitude}} />

     <InfoWindow
     onOpen={this.windowHasOpened}
     onClose={this.windowHasClosed}
          marker={this.state.activeMarker}
          visible={this.state.showingInfoWindow}>
            <div>
              <h4>{this.state.selectedPlace.alamat}</h4>
            </div>
        </InfoWindow>
</Map>
        </Col>
      

        </Modal2>

</Col>

         
         
        }
      </Page>
    );

  }
}

// const Asassment = () => {
  
// };

// export default Asassment;

export default GoogleApiWrapper({
  apiKey: 'AIzaSyC_st_Q_hTI2NwDNa5RV1E70uYs3uf_aDs'
})(Asassment);
